import {
  LogoutOutlined,
  UserOutlined,
  DownOutlined,
  MenuOutlined,
  InfoCircleOutlined,
  VideoCameraAddOutlined,
} from "@ant-design/icons";
import { Layout, Modal, Dropdown, Avatar, Button, Drawer } from "antd";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar";
import SessionManager from "../auth/sessionmanager";
import "./layout.css";
import logoEU from "../../assets/img/logoEU.png";
import { useNavigate } from "react-router-dom";
import decodeJWT from "../services/decodeJWT";

const AppLayout = (props) => {
  const [open, setOpen] = useState(false);
  const [opentutorial, setOpentutorial] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const navigate = useNavigate();
  const token = SessionManager.getToken?.();
  const role = decodeJWT(token);
  // Check screen width on mount and resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
      SessionManager.removeUserSession();
      navigate("/login");
    }, 2000);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCanceltutorial = () => {
    setOpentutorial(false);
  };

  const handleMenuClick = ({ key }) => {
    if (key === "1") {
      showModal();
    }
  };

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onDrawerClose = () => {
    setDrawerVisible(false);
  };

  const handleInfoClick = () => {
    window.open("https://hit-projects.gr/ForFreight_elearning/?redirect=0", "_blank");
  };

  const handletutorialVideoClick = () => {
    setOpentutorial(true);
  };

  const items = [
    {
      label: "Sign Out",
      key: "1",
      icon: <LogoutOutlined />,
    },
  ];

  const { Content, Sider, Header } = Layout;
  const username = SessionManager.getUserName();

  return (
    <Layout>
      {/* Desktop Sidebar - Only show when screen width >= 1000px */}
      {!isMobile && (
        <Sider
          theme="dark"
          width={270}
          style={{
            borderRadius: "0 60px 60px 0",
            position: "fixed",
            height: "100vh",
            left: 0,
            top: 0,
            zIndex: 1000,
            overflow: "auto",
          }}
        >
          <SideBar menu={props.menu} />
        </Sider>
      )}

      {/* Mobile Drawer - Only show when screen width < 1000px */}
      {isMobile && (
        <Drawer
          title="Navigation"
          placement="left"
          onClose={onDrawerClose}
          open={drawerVisible}
          width={270}
          styles={{
            body: { padding: 0 },
            header: { backgroundColor: "#001529", color: "white" },
          }}
        >
          <div style={{ backgroundColor: "#001529", height: "100%" }}>
            <SideBar menu={props.menu} />
          </div>
        </Drawer>
      )}

      {/* Main Content Layout with Conditional Left Margin */}
      <Layout style={{ marginLeft: isMobile ? 0 : 270 }}>
        {/* Sticky Header */}
        <Header
          style={{
            position: "fixed",
            top: 0,
            left: isMobile ? 0 : 273,
            right: 0,
            height: 64,
            zIndex: 1001,
            background: "white",
            padding: "0 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 2px 8px #f0f1f2",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            {/* Hamburger Menu Button - Only show on mobile */}
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={showDrawer}
                style={{
                  fontSize: "18px",
                  color: "#001529",
                  padding: "4px 8px",
                  height: "auto",
                }}
              />
            )}
            <img
              src={logoEU}
              alt="European Union Logo"
              style={{
                // width: isMobile ? "120px" : "20%",
                maxWidth: "130px",
              }}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* tutorial Icon */}
            <Button
              type="text"
              icon={<VideoCameraAddOutlined />}
              onClick={handletutorialVideoClick}
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#fff",
                width: isMobile ? "24px" : "32px",
                height: isMobile ? "24px" : "32px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F4B01B",
                border: "none",
              }}
              title="Tutorial video"
            />

            {/* Info Icon */}
            <Button
              type="text"
              icon={<InfoCircleOutlined />}
              onClick={handleInfoClick}
              style={{
                fontSize: isMobile ? "14px" : "16px",
                color: "#fff",
                width: isMobile ? "24px" : "32px",
                height: isMobile ? "24px" : "32px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F4B01B",
                border: "none",
              }}
              title="Open e-learning platform"
            />

            {/* User Dropdown */}
            <Dropdown menu={{ items, onClick: handleMenuClick }} trigger={["click"]} onOpenChange={setDropdownOpen}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: dropdownOpen ? "13px" : "10px",
                  padding: "6px 12px",
                  cursor: "pointer",
                  fontSize: isMobile ? "14px" : "16px",
                  fontWeight: "500",
                  color: "#333",
                  borderRadius: "6px",
                  transition: "all 0.4s ease-in-out",
                  background: dropdownOpen ? "#f5f5f5" : "transparent",
                  marginRight: isMobile ? 8 : 20,
                }}
              >
                <Avatar
                  size={isMobile ? "small" : "default"}
                  icon={<UserOutlined />}
                  style={{ backgroundColor: "#F4B01B", color: "#fff" }}
                />
                {!isMobile && <span style={{ color: "#001529" }}>{username}</span>}
                <DownOutlined
                  style={{
                    fontSize: "12px",
                    color: "#F4B01B",
                    transition: "transform 0.3s ease",
                    transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </div>
            </Dropdown>
          </div>

          <Modal title="Sign out" open={open} onOk={handleOk} confirmLoading={confirmLoading} onCancel={handleCancel}>
            <p>Are you sure you want to log out?</p>
          </Modal>
        </Header>
        <Modal
          title="Tutorial video"
          open={opentutorial}
          onCancel={handleCanceltutorial}
          width={800} // Increase width to fit the video better
          destroyOnClose={true}
          footer={[
            <Button key="back" onClick={handleCanceltutorial}>
              Cancel
            </Button>,
          ]}
        >
          <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden" }}>
            {role === "user" ? (
                <iframe width="737" height="415" src="https://www.youtube.com/embed/a9DQ7rsf5NM" title="FOR FREIGHT Platform General" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            ) : (
                <iframe width="737" height="389" src="https://www.youtube.com/embed/JQmdYm7tws0" title="FOR FREIGHT Platform for Developers" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
         
            )}
            ;
          </div>
        </Modal>

        {/* Content Area with Top Padding (to account for fixed header) */}
        <Content
          style={{
            marginTop: 64,
            padding: isMobile ? "12px" : "16px",
            height: "calc(100vh - 64px)",
            overflowY: "auto",
          }}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
